<template>
  <v-dialog v-model="dialogframeboton" persistent fullscreen>
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }} -
          Solicitud: {{ itemprocesos.NumeroSolicitud }} -
          {{ itemprocesos.PrimerApellido }}
          {{ itemprocesos.PrimerNombre }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="dialogframeboton = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <card-solicitud
          v-if="componenteview == 0"
          v-bind:page="dialogframeboton"
          v-on:update:page="dialogframeboton = $event"
          :infocabecera="keyproceso"
        ></card-solicitud>
        <!-- Consulta Documentos ¡-->
        <card-consultadocumentos
          v-if="componenteview == 1"
          :infollaves="llaves"
        ></card-consultadocumentos>
        <!-- Consulta Dato ¡-->
        <card-dato
          v-if="componenteview == 2"
          :NumeroSolicitud="itemprocesos.NumeroSolicitud"
          :ProcesoActual="keyproceso.proceso"
        ></card-dato>
        <!-- Consulta  Estadistico ¡-->
        <card-consultaproceso
          v-if="componenteview == 3"
          :NumeroSolicitud="itemprocesos.NumeroSolicitud"
        ></card-consultaproceso>
        <!-- Trazabilidad ¡-->
        <card-traza
          v-if="componenteview == 4"
          :NumeroSolicitud="itemprocesos.NumeroSolicitud"
          :SistemaOrigen="'2'"
        ></card-traza>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-btn
    dark
    prepend-icon="mdi-reload"
    color="red-darken-4"
    text
    @click="GetUserProcesos"
    >Actualizar bandeja</v-btn
  >
  <v-sheet class="mx-auto" elevation="8" max-width="1200">
    <v-slide-group
      v-model="model"
      class="pa-4"
      selected-class="bg-success"
      show-arrows
    >
      <v-slide-group-item
        v-for="n in cantprocesos"
        :key="n"
        v-slot="{ toggle, selectedClass }"
      >
        <v-tooltip :text="n.DescProceso">
          <template v-slot:activator="{ props }">
            <v-card
              color="blue-lighten-4"
              :class="['ma-4', selectedClass]"
              v-bind="props"
              height="60"
              width="120"
              @click="
                toggle();
                GetNumeroSolicitudProcesos(n);
              "
            >
              <v-card-item>
                <div>
                  <div align="center" class="text-caption">
                    {{ n.Sigla }}
                  </div>
                  <div align="center" class="text-caption">
                    {{ "(" + n.NumeroSolicitudes + ")" }}
                  </div>
                </div>
              </v-card-item>
            </v-card>
          </template>
        </v-tooltip>
      </v-slide-group-item>
    </v-slide-group>
  </v-sheet>
  <div class="d-flex align-center flex-column">
    <v-data-table
      v-model:page="itemsPerPage"
      :headers="headers"
      :items="desserts"
      class="elevation-1"
    >
      <template v-slot:item.Temporizador="{ item }">
        <v-chip :color="getColor(item.raw)">
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <span v-bind="props"> {{ item.raw.Temporizador }} </span>
            </template>
            <span>DD-hh:mm:ss</span>
          </v-tooltip>
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-center">
          <v-menu
            v-model="menubuttoms[item.raw.index]"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
          >
            <template v-slot:activator="{ props }">
              <v-icon color="red-darken-4" v-bind="props">
                mdi-file-settings</v-icon
              >
            </template>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <!-- Detalle de la solicitud -->
                    <v-tooltip location="bottom" color="white">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="small"
                          @click="IconosSolicitud(item.raw, 0)"
                          v-bind="props"
                          >mdi-link-variant</v-icon
                        >
                      </template>
                      <span>Detalle de la solicitud</span>
                    </v-tooltip>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <!-- Consulta de documento  -->
                    <v-tooltip location="bottom" color="white">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          @click="IconosSolicitud(item.raw, 1)"
                          color="#05AD58"
                          v-bind="props"
                          >mdi-cloud-download</v-icon
                        >
                      </template>
                      <span>Consulta de documentos</span>
                    </v-tooltip>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <!-- Histórico de datos -->
                    <v-tooltip location="bottom" color="white">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          @click="IconosSolicitud(item.raw, 2)"
                          color="cyan"
                          v-bind="props"
                          >mdi-file-multiple-outline</v-icon
                        >
                      </template>
                      <span>Histórico de datos</span>
                    </v-tooltip>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <!-- Histórico de procesos -->
                    <v-tooltip location="bottom" color="white">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          @click="IconosSolicitud(item.raw, 3)"
                          color="red"
                          v-bind="props"
                          >mdi-folder-search-outline</v-icon
                        >
                      </template>
                      <span>Histórico de procesos</span>
                    </v-tooltip>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <!-- Trazabilidad -->
                    <v-tooltip location="bottom" color="white">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          @click="IconosSolicitud(item.raw, 4)"
                          color="cyan"
                          v-bind="props"
                          >mdi-chat-processing</v-icon
                        >
                      </template>
                      <span>Trazabilidad</span>
                    </v-tooltip>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </template>
      <template v-slot:item.Identificacion="{ item }">
        <div>
          {{ item.raw.DescTypeDocument + "-" + item.raw.Identificacion }}
        </div>
      </template>
      <template v-slot:item.PrimerNombre="{ item }">
        <div>
          {{
            item.raw.PrimerNombre +
            " " +
            item.raw.SegundoNombre +
            " " +
            item.raw.PrimerApellido +
            " " +
            item.raw.SegundoApellido
          }}
        </div>
      </template>
    </v-data-table>
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DetalleSolicitud from "@/views/TCI/ProcesosO/AutomatizacionProcesos/ConstruccionPagina.vue";
import ConsultaDocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/ConsultaDocumentos.vue";
import ConsultProceso from "@/views/TCI/ProcesosO/ConsultaEstadistico/ConsultaEstadistico.vue";
import HistoricoDatos from "@/views/TCI/ProcesosO/HistoricoDatos/HistoricoDatos.vue";
import Trazabilidad from "@/views/TCI/Personas/Trazabilidad/Trazabilidad.vue";
export default {
  name: "bandeja-entrada",
  components: {
    "card-consultaproceso": ConsultProceso,
    "card-consultadocumentos": ConsultaDocumentos,
    "card-dato": HistoricoDatos,
    "card-traza": Trazabilidad,
    "card-solicitud": DetalleSolicitud,
  },
  data() {
    return {
      itemsPerPage: 1,
      progreso: false,
      model: null,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      itemprocesos: [],
      cantprocesos: [],
      keyproceso: {
        solicitud: 0,
        linea: 0,
        desclinea: "",
        proceso: 0,
        descproceso: "",
        descestado: "",
        cliente: "",
      },
      llaves: {
        Solicitud: null,
      },
      headers: [
        {
          title: "Acciones",
          align: "start",
          sortable: false,
          key: "actions",
        },
        {
          title: "Número Solicitud",
          align: "center",
          key: "NumeroSolicitud",
        },
        {
          title: "Tiempo Faltante",
          align: "center",
          key: "Temporizador",
        },
        { title: "Identificación", align: "start", key: "Identificacion" },
        { title: "Nombre Completo", align: "start", key: "PrimerNombre" },
      ],
      desserts: [],
    };
  },
  watch: {
    dialogframeboton(val) {
      if (!val) {
        this.cantprocesos = [];
        this.desserts = [];
        this.cantprocesos = [];
        this.keyproceso = {
          solicitud: 0,
          linea: 0,
          desclinea: "",
          proceso: 0,
          descproceso: "",
          descestado: "",
          cliente: "",
        };
        this.GetUserProcesos();
      }
    },
  },
  methods: {
    // Cambio de color temporizador
    getColor(itemtime) {
      if (itemtime.TotalHorasSegundos != 0 && itemtime.contador < 2) {
        if (itemtime.contador == 1) {
          return "red";
        } else {
          return "green";
        }
      } else {
        return "red";
      }
    },
    // Consulta los procesos existentes para un usuario
    GetUserProcesos() {
      this.progreso = true;
      var userperfil = this.$store.getters.userperfil;
      this.axios
        .get(
          "/Procesos/BandejaEntrada/getBandejaEntrada/" +
            userperfil.userInfo.Usuario_ID +
            "/" +
            userperfil.infoperfil.Perfil_ID
        )
        .then((response) => {
          this.cantprocesos = response.data;
          this.model = 0;
          this.GetNumeroSolicitudProcesos(this.cantprocesos[0]);
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror = registro.Mensaje || registro.ExceptionMessage;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen solicitudes pendientes.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Consulta los procesos existentes para un usuario
    GetNumeroSolicitudProcesos(proceso) {
      if (proceso.Proceso != undefined && proceso.Proceso > 0) {
        this.desserts = [];
        var userperfil = this.$store.getters.userperfil;
        this.progreso = true;
        this.axios
          .get(
            "/Procesos/BandejaEntrada/getBandejaEntradaSolicitudes/" +
              proceso.Proceso +
              "/" +
              userperfil.userInfo.Usuario_ID +
              "/" +
              userperfil.infoperfil.Perfil_ID
          )
          .then((response) => {
            this.keyproceso.linea = proceso.Linea;
            this.keyproceso.desclinea = proceso.DescLinea;
            this.keyproceso.proceso = proceso.Proceso;
            this.keyproceso.descproceso = proceso.DescProceso;
            this.desserts = response.data;
            this.itemsPerPage = 1;
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror = registro.Mensaje || registro.ExceptionMessage;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: " [404] No existen solicitudes pendientes.",
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          })
          .finally(() => {
            this.progreso = false;
          });
      } else {
        this.$swal({
          icon: "warning",
          title: "El proceso no existe.",
          html: "El proceso enviado no existe en el sistema, por favor revisar.",
        });
      }
    },
    //Control de tiempos
    updateCountdowns() {
      if (this.desserts.length > 0) {
        Object.values(this.desserts).forEach((row) => {
          //Calculo de dd-hh:mm:ss
          let seconds = row.TotalHorasSegundos;
          var numdays = Math.floor(seconds / 86400);
          numdays = numdays < 10 ? "0" + numdays : numdays;
          var numhours = Math.floor((seconds % 86400) / 3600);
          numhours = numhours < 10 ? "0" + numhours : numhours;
          var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
          numminutes = numminutes < 10 ? "0" + numminutes : numminutes;
          var numseconds = ((seconds % 86400) % 3600) % 60;
          numseconds = numseconds < 10 ? "0" + numseconds : numseconds;
          row.Temporizador =
            numdays + "-" + numhours + ":" + numminutes + ":" + numseconds;
          if (row.TotalHorasSegundos != 0 && row.contador < 2) {
            if (row.contador == 1) {
              row.TotalHorasSegundos++;
            } else {
              row.TotalHorasSegundos--;
            }
          } else {
            row.contador = 2;
            row.TotalHorasSegundos++;
          }
        });
      }
    },
    //Trabajar iconos
    IconosSolicitud(infodata, iconoelegido) {
      this.dialogframeboton = true;
      this.componenteview = iconoelegido;
      this.keyproceso.solicitud = infodata.NumeroSolicitud;
      this.itemprocesos = infodata;
      switch (iconoelegido) {
        case 0: // Cambio de prceso
          this.iconodialogbtn = "mdi-link-variant";
          this.titledialogbtn = "Detalle de la solicitud";
          break;
        case 1: // Consulta de documentos
          this.iconodialogbtn = "mdi-cloud-download";
          this.titledialogbtn = "Consulta de documentos";
          this.llaves.Solicitud = this.keyproceso.solicitud;
          break;
        case 2: //Histórico de datos
          this.iconodialogbtn = "mdi-file-multiple-outline";
          this.titledialogbtn = "Histórico de datos";
          break;
        case 3: //Histórico de procesos
          this.iconodialogbtn = "mdi-folder-search-outline";
          this.titledialogbtn = "Histórico de procesos";
          break;
        case 4: //Trazabilidad
          this.iconodialogbtn = "mdi-chat-processing";
          this.titledialogbtn = "Trazabilidad";
          break;
      }
    },
  },
  mounted() {
    this.GetUserProcesos();
    this.updateCountdowns();
    // Then update each second
    setInterval(this.updateCountdowns, 1000);
  },
};
</script>
